<div class="modal fade show d-block" id="externalLinkModal" tabindex="-1" aria-labelledby="modalTitle" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalTitle"><b>You are about to leave the MEMIC Website</b></h5>
        <!-- <button type="button" class="btn-close" (click)="onCancel()"></button> -->
      </div>
      <div class="modal-body">
        <p>PLEASE NOTE: You are about to leave the MEMIC website. MEMIC does not control the products and/or services of the subsequent website, and the party controlling the website may process data differently or provide different security than MEMIC. The linked site’s privacy notice, if any, applies while accessing the subsequent website. We recommend that you review any notices made available on the website.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">Stay Here</button>
        <button type="button" class="btn btn-primary" (click)="onConfirm()">Go To Link</button>
      </div>
    </div>
  </div>
</div>

